import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import StudentTypeService from "../../src/Services/StudentType.service";
import LookupGeneric from "./lookupGeneric";
const StudentTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'number[]'.
            return StudentTypeService.findAllById(ids);
        },
        fetchOptions: (query) => {
            return StudentTypeService.searchAll(query, 50, "name");
        },
        optionRenderer: function optionRenderer(studentType) {
            return _jsx("span", { children: studentType.name });
        },
    });
};
export default StudentTypeLookup;
